module.exports = __webpack_public_path__ + "img/2.7a982dd9.jpg";